import React from "react";
import { GridOrderItemCardsLoadingSkeleton } from "../../components/GridOrderItemCardsLoadingSkeleton";
export var BrandOrdersLoadingSkeleton = function BrandOrdersLoadingSkeleton(_ref) {
  var isLoading = _ref.isLoading;
  return isLoading ? /*#__PURE__*/React.createElement(GridOrderItemCardsLoadingSkeleton, null) : null;
};